import React from 'react';
import useMenuItems from '../hooks/reactQuery/useMenuItems';

interface IProps {
  page: string;
  children: React.ReactNode;
}

// Wraps a page that api/menu grants to admins only. The notice at the top says so on every
// visit; anyone the menu did not grant the page (a member typing the URL) sees only that.
const AdminOnly: React.FC<IProps> = ({ page, children }) => {
  const { data, isLoading } = useMenuItems();
  const allowed = (data?.pages ?? []).includes(page);

  return (
    <div className="main-content">
      <div className="page-disclaimer" role="note">
        <b>Admins only.</b> This page is only accessible to admins.
      </div>
      {allowed ? children : null}
      {!allowed && !isLoading ? (
        <div className="page-locked">
          Your account doesn&apos;t have access to this page. Ask an admin if
          you think it should.
        </div>
      ) : null}
    </div>
  );
};

export default AdminOnly;
